import type React from "react";
import { createContext, use, useState } from "react";

interface DisclaimerContextType {
    isOpen: boolean;
    messages: string[];
    link: string;
    openDisclaimer: (messages: string[], link: string) => void;
    closeDisclaimer: () => void;
}

const DisclaimerContext = createContext<DisclaimerContextType | undefined>(undefined);

export function DisclaimerProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState<string[]>([]);
    const [link, setLink] = useState("");

    const openDisclaimer = (disclaimerMessages: string[], disclaimerLink: string) => {
        setMessages(disclaimerMessages);
        setLink(disclaimerLink);
        setIsOpen(true);
    };

    const closeDisclaimer = () => {
        setIsOpen(false);
        setMessages([]);
        setLink("");
    };

    return (
        <DisclaimerContext value={{ isOpen, messages, link, openDisclaimer, closeDisclaimer }}>
            {children}
        </DisclaimerContext>
    );
}

export function useDisclaimer() {
    const context = use(DisclaimerContext);
    if (!context) {
        throw new Error("useDisclaimer must be used within DisclaimerProvider");
    }
    return context;
}
